export const DATE_FORMAT = 'YYYY-MM-DD';
export const PRETTY_DATE_FORMAT = 'MMMM Do[,] YYYY';
export const TIME_FORMAT = 'HH:mm';
